import { CompatibleProductTypeValues, HostingDisplayName } from '@atlassian/mpac-types';
import { formatVersionRange } from "../../../AppListing.utils";

var getCompatibleVersionsSummary = function getCompatibleVersionsSummary(props) {
  if (props.productCompatibilities.length < 1) {
    return '';
  }

  var getCompatibilitySummary = function getCompatibilitySummary(compatibility) {
    var productName = compatibility.atlassianProduct ? "".concat(compatibility.atlassianProduct.name, " ").concat(HostingDisplayName[props.hosting]) : '';

    switch (compatibility.__typename) {
      case CompatibleProductTypeValues.CLOUD_PRODUCT:
        return productName;

      case CompatibleProductTypeValues.SERVER_PRODUCT:
      case CompatibleProductTypeValues.DATACENTER_PRODUCT:
        {
          var minimumVersion = compatibility.minimumVersion,
              maximumVersion = compatibility.maximumVersion;
          return "".concat(productName, " ").concat(formatVersionRange({
            minimumVersion: minimumVersion,
            maximumVersion: maximumVersion
          }));
        }
    }
  };

  return props.productCompatibilities.map(getCompatibilitySummary).join(', ');
};

export default getCompatibleVersionsSummary;